import React from 'react';
import { CprIcon, CprLoader, CpButton } from 'canopy-styleguide!sofe';
import { RecentResults } from './search/recent-results.component';
import { SearchResults } from './search/search-results.component';

import styles from './secondary-navs.styles.css';

export const BaseNav = ({ title, nav, searchHook = {}, searchParams = {}, categories, navLinks, newClientList }) => {
  const showNavLinks = (!searchParams.showSearch || !searchHook.searchString || !searchHook.searchResults || searchHook.searchResults.length === 0);
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={`cps-wt-semibold ${styles.title}`}>{title}</div>
        <CpButton
          icon="close-large"
          aria-label="close"
          onClick={() => nav.setSecondaryOpen(null)}
        />
      </header>
      {searchParams.showSearch && (
        <section className={styles.search}>
          <div>
            <input
              type="text"
              ref={searchHook.searchInput}
              value={searchHook.searchString}
              className="cps-form-control"
              onChange={searchHook.handleSearch}
              placeholder={`Search ${searchParams.placeholder}...`}
            />
          </div>
          {searchHook.loading ? (
            <CprLoader className="cps-padding-24" />
          ) : searchParams.showRecent && searchHook.searchString.length === 0 ? (
            <RecentResults
              userId={nav.user.id}
              storageKey={searchParams.recentStorageKey}
              closeNav={() => nav.setSecondaryOpen(null)}
              newClientList={newClientList}
            />
          ) : searchHook.searchResults.length > 0 ? (
            <SearchResults
              list={searchHook.searchResults}
              categories={categories}
              link={searchParams.link}
              displayKey={searchParams.displayKey}
              closeNav={() => nav.setSecondaryOpen(null)}
              searchTerm={searchHook.searchString}
              hoverIndex={searchHook.hoverIndex}
            />
          ) : null}
        </section>
      )}
      {showNavLinks && (
        <section style={{ marginTop: '24px' }}>
          <ul className={styles.navLinks}>
            {navLinks.map(
              navLink =>
                navLink.enabled && (
                  <li key={navLink.label} className="cps-wt-semibold" onClick={() => nav.setSecondaryOpen(null)}>
                    <a href={`/#/${navLink.url}`} className={styles.navLink}>
                      <div>{navLink.label}</div>
                      <CprIcon name="caret-large-right" />
                    </a>
                  </li>
                )
            )}
          </ul>
        </section>
      )}
    </div>
  )
};
